import React from "react";
import styles from "./user-card.module.css";
import { DEFAULT_PROFILE_IMAGE } from "../../../../../../constants/common";
import { formatChatTimestamp } from "../../../../../../utils/format-date/format-date";
import { useChat } from "../../../../../../context/chat-context";
  
const UserCard = ({
  name,
  lastmessage = "",
  timeAgo = "",
  imgUrl,
  onClick = () => {},
  active = false,
  isOnline = false,
  isNewChat = false,
  unreadCount = 0,
}) => {
  const { isSupportPath } = useChat();

  return (
    <div 
      className={`${styles["user-stat-card"]} ${styles[!isNewChat && active ? 'active' : '']}`}
      onClick={() => onClick()}
    >
      <div className={styles["user-card"]}>
        <div className={styles["chat-profile-wrapper"]}>
          <img 
            src={imgUrl ? imgUrl : DEFAULT_PROFILE_IMAGE}
            height={44}
            width={44}
            className={styles["chat-profile"]}
            alt="profile" 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = DEFAULT_PROFILE_IMAGE;
            }}
          />
          {!isNewChat && !isSupportPath && (
            <span className={`${styles["status-dot"]} ${styles[isOnline ? 'online' : 'offline']}`} />
          )}
        </div>
        <div>
          <p className={styles["user-name"]}>{name}</p>
          <p className={styles["last-message"]}>{lastmessage}</p>
        </div>
      </div>
      <div>
        <p className={styles["last-message"]}>{formatChatTimestamp(timeAgo)}</p>
        {unreadCount ? (
          <p className={styles["count-badge"]}>{unreadCount}</p>
        ) : null}
      </div>
    </div>
  );
};
export default UserCard;
